import { useInspectionReportModels } from '@euler/app/flows/report/functions';
import { ProductManifestProps } from '@euler/app/flows/report/types';
import { FaultInspectionItem } from '@euler/model/FaultInspectionItem';
import { VehicleReport } from '@euler/model/report';
import { memo } from 'react';
import { ScrollViewProps } from 'react-native';
import { InspectionResultsView } from './InspectionResultsView';

export const InspectionReportView = memo(
  ({
    report,
    flowId,
    productManifest,
    faultLikeSubject,
    ...scrollViewProps
  }: {
    report: VehicleReport;
    flowId?: string;
    productManifest?: ProductManifestProps;
    faultLikeSubject?: FaultInspectionItem;
  } & ScrollViewProps) => {
    const { cells } = useInspectionReportModels(report, {
      flowId,
      faultLikeSubject,
    });
    return (
      <InspectionResultsView
        cells={cells}
        productManifest={productManifest}
        faultLikeSubject={faultLikeSubject}
        {...scrollViewProps}
      />
    );
  },
);
